import { render, staticRenderFns } from "./DetalheSomenteClientesSemFaturamento.vue?vue&type=template&id=7f129cb5&"
import script from "./DetalheSomenteClientesSemFaturamento.vue?vue&type=script&lang=js&"
export * from "./DetalheSomenteClientesSemFaturamento.vue?vue&type=script&lang=js&"
import style0 from "./DetalheSomenteClientesSemFaturamento.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./DetalheSomenteClientesSemFaturamento.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VContainer,VDataTable,VDatePicker,VDivider,VIcon,VMenu,VRow,VSelect,VTextField,VTooltip})
